/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext } from "react";
import { Card, Grid, Button, CardContent, CardActions } from "@mui/material";
import { type IProduct, IconType } from "../services/model/product";
import ProductIcon from "./ProductIcon";
import { BrandingContext } from "@/branding/BrandingProvider";

interface DashboardItemProps {
  style?: any;
  loading: boolean;
  productData: IProduct;
  buttonClickEvent: any;
}

const DashboardItem: React.FC<DashboardItemProps> = (props) => {
  const { productData, buttonClickEvent } = props;
  const branding = useContext(BrandingContext);

  const productButtonStyle = {
    marginLeft: "10%",
    marginRight: "10%",
    width: "80%",
    height: "80%",
  };

  return (
    <>
      <Grid size={12}>
        <Grid container size={12} justifyContent="center">
          <Card
            onClick={() => buttonClickEvent(productData)}
            variant="outlined"
            style={
              productData.isPanic
                ? {
                    color: "white",
                    borderColor: branding?.primaryColor,
                    background: branding?.primaryColor,
                    width: "65%",
                    borderRadius: "5%",
                  }
                : {
                    color: branding?.secondaryColor,
                    borderColor: "#e0e0e0",
                    background: "#fff",
                  }
            }
          >
            <CardContent
              style={{
                paddingTop: "5px",
                paddingBottom: "0",
                textJustify: "auto",
              }}
            >
              {/* Default Icon */}
              {(productData.iconType === null ||
                productData.iconType === undefined) && (
                <ProductIcon
                  name={
                    productData.isPanic
                      ? "notification_important"
                      : "add_ic_call"
                  }
                  style={productButtonStyle}
                  color={productData.isPanic ? undefined : "primary"}
                />
              )}
              {/* Custom Material UI Icon */}
              {productData.iconType === IconType.MaterialUIIcon && (
                <ProductIcon
                  name={productData.icon}
                  style={productButtonStyle}
                  color={productData.isPanic ? undefined : "primary"}
                />
              )}
              {/* TODO: Add more icon types here */}
            </CardContent>
            <CardActions style={{ paddingTop: "0", paddingBottom: "0" }}>
              {productData.isPanic && (
                <Button
                  fullWidth
                  style={{ color: "white", paddingTop: "0", minHeight: "40px" }}
                >
                  <strong>{productData.name}</strong>
                </Button>
              )}
              {!productData.isPanic && (
                <Button
                  fullWidth
                  color="primary"
                  style={{
                    fontSize: "10px",
                    paddingTop: "0",
                    minHeight: "40px",
                  }}
                >
                  <strong>{productData.name}</strong>
                </Button>
              )}
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default DashboardItem;
